import { createContext } from 'react'

export const SetIdContext = createContext(null)

export const OfficeContext = createContext(null)

export const ToDisplayNameContext = createContext(null)
